import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
} from "@mui/material";

export const ConfirmDialog = ({
    open,
    onClose,
    title,
    message,
    onConfirm,
    confirmText,
    cancelText = "Cancel",
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>
          {message}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          color="inherit"
          sx={{
            textTransform: "none",
            borderRadius: 2,
            px: 3,
            py: 1,
            borderColor: "grey.300",
          }}
        >
          {cancelText}
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          sx={{
            textTransform: "none",
            borderRadius: 2,
            px: 3,
            py: 1,
            boxShadow: 2,
            "&:hover": {
              boxShadow: 4,
              backgroundColor: "error.dark",
            },
          }}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
